import { G_TAG_ID } from "../../utils/observability/googleTagManager";
import settings from "../../constants/settings";
import { GoogleTagManager } from "@next/third-parties/google";
import useSyncFlags from "../../utils/hooks/flags";

export default function Analytics() {
  useSyncFlags();

  if (settings.google_analytics_enabled) {
    return <GoogleTagManager gtmId={G_TAG_ID} />;
  } else {
    return null;
  }
}
